/**
 * Identificador (slug) de un cliente nuevo en la consola de plataforma
 * (OT-0073 §4.3). El estado de una organización vive en `organizationState`.
 */

// Misma regla que `TenantProvisioningService._validate_slug` del backend
// (`_SLUG_RE`, `tenants.slug` VARCHAR 50, prefijo `test-` reservado). Aquí es
// sólo para avisar mientras se escribe; la autoridad es el backend.

export const CLIENT_SLUG_MAX_LENGTH = 50
const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
const RESERVED_PREFIX = 'test-'

export type SlugIssue = 'format' | 'reserved_prefix' | 'too_long'

export function slugIssue(slug: string): SlugIssue | null {
  if (slug.length > CLIENT_SLUG_MAX_LENGTH) return 'too_long'
  if (!SLUG_RE.test(slug)) return 'format'
  if (slug.startsWith(RESERVED_PREFIX)) return 'reserved_prefix'
  return null
}

/** "Acme Corp, S.A." → "acme-corp-s-a". */
export function suggestSlug(displayName: string): string {
  return displayName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, CLIENT_SLUG_MAX_LENGTH)
    .replace(/-+$/, '')
}
